
<mat-progress-bar
  mode="indeterminate"
  *ngIf="loading$ | async">
</mat-progress-bar>

<router-outlet></router-outlet>